import { Product, Role } from 'models'
import {
  list as baseList,
  show as baseShow,
  create as baseCreate,
  edit as baseEdit,
  destroy as baseDestroy
} from 'services/billing'
import { ListResult, QueryOptions, ReadResult } from 'interfaces/queryOptions'
import { checkRoles } from 'utils'

export async function list(
  options: QueryOptions = {}
): Promise<ListResult<Product>> {
  return await baseList<Product>('/products', options)
}

export async function show(
  id: number | string
): Promise<
  Partial<Product> & { id: number; relationships?: Record<string, any> }
> {
  const response = await baseShow<Product>('/products', id)
  return {
    ...response.attributes,
    id: response.id,
    relationships: response.relationships
  }
}

export async function create(
  attributes: Partial<Product>
): Promise<ReadResult<Product>> {
  await checkRoles([Role.MANAGER])
  const data = { attributes }
  return await baseCreate<Product>('/products', data)
}

export async function update(
  id: number | string,
  attributes: Partial<Product>
): Promise<ReadResult<Product>> {
  await checkRoles([Role.MANAGER])
  return await baseEdit<Product>('/products', id, { attributes })
}

export async function toggle(
  id: number | string,
  isActive: boolean
): Promise<ReadResult<Product>> {
  await checkRoles([Role.MANAGER])
  return await baseEdit<Product>('/products', id, {
    attributes: { active: !isActive }
  })
}

export async function destroy(id: number | string): Promise<void> {
  await checkRoles([Role.MANAGER])
  await baseDestroy('/products', id)
}
